export enum PatientStatusCode {
  Admitted = 'patient.status.admitted',
  Onboarded = 'patient.status.onboarded',
  Discharged = 'patient.status.discharged',
  Invalidated = 'patient.status.invalidated',
}
